<template>
  <div class="container">
    <div class="row">
      <div class="col col-lg-1">
        <!-- Potentially add desktop breadcrumbs here -->
      </div>
      <div class="col-lg-10">
        <!-- Main content -->
        <slot></slot>
      </div>
      <div class="col col-lg-1">
        <!-- Potentially add right-side desktop content here -->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'simple-container-layout'
}
</script>
